<template>
    <div id="offers-in-cart" v-if="productsInCart.length > 0 && webstoreContent">
        <div class="selected-offer" v-for="offer in productsInCart" :key="offer">
            <Offer 
                :offer="offer"
                :editable="editable"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Offer from './offer';

    export default {

        components: {Offer},

        props: {
            editable: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
            }
        },

        computed: {

            ...mapGetters('content', [
                'webstoreContent',
            ]),

            ...mapGetters('shoppingCart', [
                'productsInCart',
            ]),
        },
    }
</script>

<style scoped>

    #offers-in-cart {
        font-family:  "Nitti Grotesk", sans-serif;
        font-style: normal;
        font-weight: normal;
    }


    .selected-offer {
        border-bottom: 1px solid #E4E7EB;

        padding-bottom: 3%;
    }

</style>